/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 7/26/20
 *
 */
import PaymentIntegrationItem from "@shared/Billing/PaymentIntegrationItem";
import PaymentIntegrationType from "@shared/Billing/PaymentIntegrationType";

export default class PayPalIntegrationItem extends PaymentIntegrationItem {

	email: string = ""
	clientId: string = ""
	secret: string = ""


	constructor() {
		super();
		this.type = PaymentIntegrationType.PAYPAL
		this.title = "PayPal"
	}
}
